export const tokenInfoUrl = 'https://api.eposnowhq.com/api/v4/TokenInfo/';
